import React, { Component } from 'react';
import { Row, Col, Breadcrumb, Spin, Button } from 'antd';
import { Link } from 'react-router-dom';
import Card from '../../components/Card';
import logo from '../../assets/LOGO_1.png';
import { api, app, config } from "../../app";
import default_img from "../../assets/head_default_img.png";
import '../../css/players.css';

function toGR(history, obj, token) {
    console.log(token);
    history.push(`/player/${obj.team_id}/${obj.indexno}?token=${token}`);
}

function DataShow({ loading, dataInfo, history, teamno, token }) {
    if (loading) {
        return (<Row type="flex" align="middle" justify="center" className="data_loading"><Spin
            tip="正在加载中..."></Spin></Row>)
    }
    const no_data = (<Row type="flex" justify="middle" align="center" style={{ width: "100%", height: 60 }}>暂无</Row>);
    let teamheader = dataInfo.teamheader, //队长
        administrator = dataInfo.administrator || [], //管理员
        headerStr = '暂无', //队长名字结合字符串
        adminStr = '暂无', //管理员名字结合字符串
        adminNode = '', //管理员节点
        headNode = '', //队长节点
        ndrdNode = no_data,   //年度入队人员
        rzNode = no_data,   //认证队员节点
        norzNode = no_data,   //队员节点
        ybNode = no_data,     //预备队员节点
        zyzNode = no_data,     //志愿者节点
        ldNode = no_data,     //离队节点
        kcNode = no_data,     //清退节点
        yearJoin = dataInfo.yearJoin || [], //年度入队队员
        RZ = dataInfo.RZ || [], //认证队员
        NORZ = dataInfo.NORZ || [], //队员
        YBDY = dataInfo.YBDY || [], //预备队员
        ZYZ = dataInfo.ZYZ || [], //志愿者
        LD = dataInfo.LD || [], //离队队员
        KC = dataInfo.KC || []; //清退队员

    //判断队长信息
    if (teamheader.length > 0) {
        teamheader = dataInfo.teamheader || [];
        headerStr = teamheader.map((admin, index) => {
            return <Link key={index} style={{ padding: "0 8px" }} to={`/player/${teamno}/${admin.indexno}?token=${token}`}>{admin.vname}</Link>
        });
        headNode = (
            <Row className="p_c_l_teamHead">
                <p>队长</p>
                {
                    teamheader.map((team, index) => {
                        return (
                            <Row className="item" type="flex" key={index} onClick={() => {
                                toGR(history, team, token)
                            }}>
                                <Col span={6}>
                                    <div className="big_tx">
                                        <img alt="" style={{ width: "100%", height: "100%" }}
                                            src={team.localpath ? (config.imgUrl + app.urlEncode(team.localpath)) : default_img} />
                                    </div>
                                </Col>
                                <Col span={18} style={{ paddingLeft: 20 }}>
                                    <Row type="flex" className="text_item">
                                        <Col className="title">姓名:</Col>
                                        <Col className="content">{team.vname}</Col>
                                    </Row>
                                    <Row type="flex" className="text_item">
                                        <Col className="title">存心编号:</Col>
                                        <Col className="content">{team.bsrno}</Col>
                                    </Row>
                                </Col>
                            </Row>
                        );
                    })
                }
            </Row>
        );
    } else {
        teamheader = { vname: '暂无' };
    }

    //判断管理员信息
    if (administrator.length > 0) {
        adminStr = administrator.map((admin, index) => {
            return <Link key={index} style={{ padding: "0 8px" }} to={`/player/${teamno}/${admin.indexno}?token=${token}`}>{admin.vname}</Link>
        });
        adminNode = (
            <Row className="p_c_l_teamAdmin">
                <p>管理员</p>
                {
                    administrator.map((admin, index) => {
                        return (
                            <Row key={index + 1} className="item" type="flex" onClick={() => {
                                toGR(history, admin, token)
                            }}>
                                <Col span={6}><img className="small_tx" alt=""
                                    src={admin.localpath ? (config.imgUrl + app.urlEncode(admin.localpath)) : default_img} /></Col>
                                <Col span={18}>
                                    <Row type="flex" className="text_item">
                                        <Col className="title">姓名:</Col>
                                        <Col className="content">{admin.vname}</Col>
                                    </Row>
                                    <Row type="flex" className="text_item">
                                        <Col className="title">存心编号:</Col>
                                        <Col className="content">{admin.bsrno}</Col>
                                    </Row>
                                </Col>
                            </Row>
                        )
                    })
                }
            </Row>
        );
    }

    //判断年度入队人员
    if (yearJoin.length > 0) {
        ndrdNode = (
            yearJoin.map((no, index) => {
                return (
                    <div key={index + 1} className="item" onClick={() => {
                        toGR(history, no, token)
                    }}>
                        <img className="small_tx" alt=""
                            src={no.localpath ? (config.imgUrl + app.urlEncode(no.localpath)) : default_img} />
                        <div>
                            <p className="text_item">姓名: <span>{no.vname}</span></p>
                            <p className="text_item">存心编号: <span>{no.bsrno}</span></p>
                        </div>
                    </div>
                )
            }));
    }

    //判断认证队员
    if (RZ.length > 0) {
        rzNode = (
            RZ.map((no, index) => {
                return (
                    <div key={index + 1} className="item" onClick={() => {
                        toGR(history, no, token)
                    }}>
                        <img className="small_tx" alt=""
                            src={no.localpath ? (config.imgUrl + app.urlEncode(no.localpath)) : default_img} />
                        <div>
                            <p className="text_item">姓名: <span>{no.vname}</span></p>
                            <p className="text_item">存心编号: <span>{no.bsrno}</span></p>
                        </div>
                    </div>
                )
            }));
    }

    //判断队员
    if (NORZ.length > 0) {
        norzNode = (
            NORZ.map((no, index) => {
                return (
                    <div key={index + 1} className="item" onClick={() => {
                        toGR(history, no, token)
                    }}>
                        <img className="small_tx" alt=""
                            src={no.localpath ? (config.imgUrl + app.urlEncode(no.localpath)) : default_img} />
                        <div>
                            <p className="text_item">姓名: <span>{no.vname}</span></p>
                            <p className="text_item">存心编号: <span>{no.bsrno}</span></p>
                        </div>
                    </div>
                )
            }));
    }

    //判断预备队员
    if (YBDY.length > 0) {
        ybNode = (
            YBDY.map((no, index) => {
                return (
                    <div key={index + 1} className="item" onClick={() => {
                        toGR(history, no, token)
                    }}>
                        <img className="small_tx" alt=""
                            src={no.localpath ? (config.imgUrl + app.urlEncode(no.localpath)) : default_img} />
                        <div>
                            <p className="text_item">姓名: <span>{no.vname}</span></p>
                            <p className="text_item">存心编号: <span>{no.bsrno}</span></p>
                        </div>
                    </div>
                )
            }));
    }

    //判断志愿者
    if (ZYZ.length > 0) {
        zyzNode = (
            ZYZ.map((no, index) => {
                return (
                    <div key={index + 1} className="item" onClick={() => {
                        toGR(history, no, token)
                    }}>
                        <img className="small_tx" alt=""
                            src={no.localpath ? (config.imgUrl + app.urlEncode(no.localpath)) : default_img} />
                        <div>
                            <p className="text_item">姓名: <span>{no.vname}</span></p>
                            <p className="text_item">存心编号: <span>{no.bsrno}</span></p>
                        </div>
                    </div>
                )
            }));
    }

    //判断离队队员
    if (LD.length > 0) {
        ldNode = (
            LD.map((no, index) => {
                return (
                    <div key={index + 1} className="item" onClick={() => {
                        toGR(history, no, token)
                    }}>
                        <img className="small_tx" alt=""
                            src={no.localpath ? (config.imgUrl + app.urlEncode(no.localpath)) : default_img} />
                        <div>
                            <p className="text_item">姓名: <span>{no.vname}</span></p>
                            <p className="text_item">存心编号: <span>{no.bsrno}</span></p>
                        </div>
                    </div>
                )
            }));
    }


    //判断清退队员
    if (KC.length > 0) {
        kcNode = (
            KC.map((no, index) => {
                return (
                    <div key={index + 1} className="item" onClick={() => {
                        toGR(history, no, token)
                    }}>
                        <img className="small_tx" alt=""
                            src={no.localpath ? (config.imgUrl + app.urlEncode(no.localpath)) : default_img} />
                        <div>
                            <p className="text_item">姓名: <span>{no.vname}</span></p>
                            <p className="text_item">存心编号: <span>{no.bsrno}</span></p>
                        </div>
                    </div>
                )
            }));
    }

    return (
        <Row className="ranks_players_content" gutter={50}>
            <Col span={6} className="players_content_left">
                <Card width="100%" height="100%" title={dataInfo.teamname}>
                    <Row className="p_c_l_info" type="flex" align="middle">
                        <Col span={10}><img src={logo} width="80%" alt="" /></Col>
                        <Col span={14}>
                            <Row type="flex" className="text_item">
                                <Col className="title">队长</Col>
                                <Col className="content">{headerStr}</Col>
                            </Row>
                            <Row type="flex" className="text_item">
                                <Col className="title">管理员</Col>
                                <Col className="content">{adminStr}</Col>
                            </Row>
                            <Row type="flex" className="text_item">
                                <Col className="title">队伍编号</Col>
                                <Col className="content">{dataInfo.teamno}</Col>
                            </Row>
                        </Col>
                    </Row>
                    {headNode}
                    {adminNode}
                </Card>
            </Col>
            <Col span={18} className="players_content_right_top">
                <Card width="100%" title={"年度入队人员"} style={{ padding: "0 20px" }}>
                    {ndrdNode}
                </Card>
                <Card width="100%" title={"认证队员"} style={{ padding: "0 20px" }}>
                    {rzNode}
                </Card>
                <Card width="100%" title={"队员"} style={{ padding: "0 20px" }}>
                    {norzNode}
                </Card>
                {/*<Card width="100%" title={"预备队员"} style={{ padding: "0 20px" }}>*/}
                {/*    {ybNode}*/}
                {/*</Card>*/}
                {/*<Card width="100%" title={"认证志愿者"} style={{ padding: "0 20px" }}>*/}
                {/*    {zyzNode}*/}
                {/*</Card>*/}
                <Card width="100%" title={"离队人员"} style={{ padding: "0 20px" }}>
                    {ldNode}
                </Card>
                <Card width="100%" title={"清退人员"} style={{ padding: "0 20px" }}>
                    {kcNode}
                </Card>
            </Col>
        </Row>
    )
};

class Players extends Component {
    constructor(props) {
        super(props);
        const teamno = props.match.params.teamno;
        this.state = {
            token: '',
            data_loading: true,
            teamno: teamno,
            dataInfo: {}
        };
        this.mounted = false;
    }

    componentDidMount() {
        this.getTokeni();
        this.dataSource();
    }

    /**
     * 数据源
     */
    dataSource = () => {
        const _this = this, teamno = this.state.teamno;
        app.post(api.GetTeamUser, { teamno }).then(({ flag, data, msg }) => {
            if (flag === 1) {
                _this.setState({ dataInfo: data });
                app.setData('link_teamno', teamno);
            } else {
                app.alert(msg, "error");
            }
            _this.setState({ data_loading: false });
        });
    }

    /**
    * 获取token
    * @returns {Promise<void>}
    */
    getTokeni = async () => {
        let { flag, data, msg } = await app.post(api.getToken);
        if (flag === 1) {
            this.setState({
                token: data.token
            });
        } else {
            app.alert(msg, 'warn');
        }
    };

    render() {
        const dataInfo = this.state.dataInfo, loading = this.state.data_loading, token = this.state.token,
            province = app.getData('link_province'), teamno = app.getData('link_teamno');
        return (
            <div className="ranks_content">
                <Row type="flex" justify="space-between" className="r_page_title">
                    <div>队伍<span>Team</span></div>
                    <Button icon="rollback" onClick={() => app.backPage(this)}>返回</Button>
                </Row>
                <Breadcrumb separator=">" className="r_right_breadcrumb">
                    <Breadcrumb.Item><Link to="/">首页</Link></Breadcrumb.Item>
                    {province ? (
                        <Breadcrumb.Item><Link to={"/ranks/pro/" + province}>队伍列表</Link></Breadcrumb.Item>) : ''}
                    {teamno ? (
                        <Breadcrumb.Item><Link to={"/ranks/team/" + teamno}>团队</Link></Breadcrumb.Item>) : ''}
                    <Breadcrumb.Item>队员列表</Breadcrumb.Item>
                </Breadcrumb>
                <DataShow dataInfo={dataInfo} loading={loading} history={this.props.history} teamno={teamno} token={token}></DataShow>
            </div>
        );
    }
}

export default Players;



// WEBPACK FOOTER //
// ./src/routes/playerInfo/Players.jsx